export default __webpack_public_path__ + "3f4b2f4c0d594dfebf367f81b8b28111.png";